/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOwnFundDto } from '../../models/backend-actual-own-fund-dto';
import { BackendPatchedActualOwnFundRequestDto } from '../../models/backend-patched-actual-own-fund-request-dto';

export interface MonitoringActualsOwnFundPartialUpdate$Params {
  id: number;
  body?: BackendPatchedActualOwnFundRequestDto;
}

export function monitoringActualsOwnFundPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOwnFundPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOwnFundPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOwnFundDto>;
    }),
  );
}

monitoringActualsOwnFundPartialUpdate.PATH = '/api/monitoring/actuals/own-fund/{id}/';
